export * from './schedaintense-main.component';
